<template>
  <div class="content">
    <div class="content__container">
      <h2>
        <img
          :src="tenant.logoLight"
          alt=""
          width="240px;"
          height="160px;"
        />
      </h2>
      <br />
      <form @submit.prevent="submit">
        <input
          v-model="email"
          class="form-control input"
          type="email"
          name="email"
          placeholder="Digite seu e-mail"
          autocomplete="off"
          required
        />
        <input
          v-model="password"
          class="form-control input"
          type="password"
          name="password"
          placeholder="Digite sua senha"
          required
        />
        <button class="btn btn-block btn-default btn--login" type="submit">
          Entrar
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions } from "vuex";

export default {
  data: function() {
    return {
      email: "",
      password: ""
    };
  },
  methods: {
    ...mapActions(["login", "logout"]),
    async submit() {
      try {
        await this.login({ email: this.email, password: this.password });
        this.$router.push("/");
      } catch (err) {
        if (err.response) {
          Swal.fire("Ops!", "Email ou senha incorreto.", "error");
        } else {
          Swal.fire("Ops!", "Não foi possível conectar com o servidor.", "error");
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.content {
  background-image: url("../../../src/assets/img/imagem-login2.png");
  background-size: cover;
  margin: 0;
  padding: 0;
  box-sizing: border-box;

  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Arial, Helvetica, sans-serif;
  height: 100vh;

  &__container {
    width: 100%;
    max-width: 500px;
    padding: 10px;
    text-align: center;

    img {
      margin-top: -120px;
    }

    h2 {
      color: #727274;
      font-size: 25px;
      text-transform: uppercase;
      letter-spacing: 1em;
      span {
        color: #030736;
      }
    }

    form a {
      text-decoration: none;
    }

    p {
      margin-top: 50px;
      color: #757575;
      line-height: 22px;
    }

    h2 {
      margin-top: 100px;
      color: #ffffff;
      font-weight: normal;
    }

    .input {
      background-color: #0b0a0d;
      border: 1px solid #757575;
      border-radius: 5px;
      color: #fff;
      opacity: 0.5;
      font-size: 16px;
      margin: 0 auto 20px;
      width: 78%;
      padding: 25px;
    }

    .input:focus,
    select:focus {
      border-color: #a9cd84 !important;
      background-color: #0b0a0d;
      opacity: 0.5;
      outline: 0;
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
    }

    .btn-default {
      background-color: #727274;
      border: none;
      border-radius: 5px;
      font-size: 16px;
      color: #fff;
      width: 80%;
      margin: 0 auto 20px;
      padding: 20px;
      transition: all 0.5s;
    }
    .btn-exit {
      background-color: #030854;
      color: #fff;
    }
    .btn--login {
      background-color: #84a85f;
      filter: brightness(70%);
    }
  }
}
</style>

